module.exports = __webpack_public_path__ + "img/5400.a7df74b0.jpg";